/**
 * @file Favorite photos related utilities.
 */

import get from 'lodash.get';

/**
 * Returns an array of all photo ids belonging to photo favorites.
 *
 * @param {Array<FavoritePhoto>} favoritePhotos The favorite photos.
 * @returns {Array<String>} An array of all favorite photo ids.
 */
const getFavoritePhotoIds = favoritePhotos => {
  if (!favoritePhotos) {
    return [];
  }

  return favoritePhotos.map(favoritePhoto => get(favoritePhoto, 'photo.id'));
};

/**
 * Determines whether a photo is part of the favorite photo IDs
 * (is favorite).
 *
 * @param {Array<FavoritePhoto>} favoritePhotos The favorite photos.
 * @param {String} photoId The photo id to check.
 * @returns {Boolean} Whether the photo is favorited.
 */
const isPhotoFavorited = (favoritePhotos = [], photoId) => {
  if (!favoritePhotos.length || !photoId) {
    return false;
  }

  return getFavoritePhotoIds(favoritePhotos).includes(photoId);
};

/**
 * Given an array of FavoritePhotos and a photoId finds
 * the FavoritePhoto that the supplied photoId refers to.
 *
 * @param {Array<FavoritePhoto>} favoritePhotos The favorite photos.
 * @param {String} photoId The photo id to find.
 * @returns {FavoritePhoto}
 */
const getFavoritePhotoByPhotoId = (favoritePhotos = [], photoId) => {
  return favoritePhotos.find(({ photo }) => photo.id === photoId);
};

export { getFavoritePhotoIds, isPhotoFavorited, getFavoritePhotoByPhotoId };
